import script from "./CardUserDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardUserDetail.vue?vue&type=script&setup=true&lang=ts"

import "./CardUserDetail.vue?vue&type=style&index=0&id=71f39422&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71f39422"]])

export default __exports__